/** @flow */
import { Record } from 'immutable';

import {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR,
  PUSH_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  REMOVE_NOTIFICATION,
  UPDATE_NOTIFICATION,
  READ_NOTIFICATION,
} from '../actions/uiActions';
import type { UiState } from '../types/State';
import Notification from '../domain/Notification';

export const InitialState = Record({
  snackbar: Record({
    isShowing: false,
    kind: null,
    message: '',
  })(),
  notifications: [],
});

export type NotificationsState = {
  snackbar: {
    isShowing: boolean,
    kind: any,
    message: string,
  },
  notifications: Notification[]
}

function findNotification(state: UiState, reference: string): Notification {
  return state.notifications.find(n => n.reference === reference);
}

function pushOrUpdateNotification(state: UiState, notification: Notification) {
  const notifications = state.notifications.slice();

  const notificationIdx = notifications.findIndex(n => n.isSame(notification));
  if (notificationIdx >= 0) {
    notifications[notificationIdx] = notification;
    return notifications;
  }

  return [notification].concat(notifications);
}

export default (state: Record<NotificationsState> = InitialState(), action: Object) => {
  switch (action.type) {
    case OPEN_SNACKBAR:
      // $FlowFixMe
      return state.setIn(['snackbar', 'isShowing'], true)
        .setIn(['snackbar', 'kind'], action.kind)
        .setIn(['snackbar', 'message'], action.message);
    case CLOSE_SNACKBAR:
      // $FlowFixMe
      return state.setIn(['snackbar', 'isShowing'], false);
    case PUSH_NOTIFICATION: // fall-through
    case UPDATE_NOTIFICATION:
      return state.set('notifications', pushOrUpdateNotification(state, action.notification));
    case CLEAR_NOTIFICATIONS:
      return state.set('notifications', []);
    case REMOVE_NOTIFICATION:
      return state.set('notifications', state.get('notifications').filter(n => !n.isSame(action.notification)));
    case READ_NOTIFICATION: {
      const notification = findNotification(state, action.reference);
      if (notification) {
        const readedNotification = notification.markRead();
        return state.set('notifications', pushOrUpdateNotification(state, readedNotification));
      }
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/common/modules/ui/reducers/uiReducer.js